import { Button, Form, Input } from 'antd';
import React from 'react';

import useStandards from '../../../hooks/useStandards';

type StandardsFormData = {
  label: string;
  description: string;
};

const ManageStandardsForm = () => {
  const { createStandard, isCreatingStandard } = useStandards({ isGenerator: false });

  const [form] = Form.useForm();

  const onFinish = async (values: StandardsFormData) => {
    await createStandard({
      label: values.label,
      description: values.description,
    });
    form.resetFields();
  };

  return (
    <Form name="manage_standards" layout="vertical" onFinish={onFinish} form={form}>
      <Form.Item
        label="Label"
        name="label"
        rules={[{ required: true, message: 'Please input the label!' }]}
      >
        <Input placeholder="Enter label" />
      </Form.Item>

      <Form.Item
        label="Description"
        name="description"
        rules={[{ required: true, message: 'Please input the description!' }]}
      >
        <Input.TextArea placeholder="Enter description" rows={4} />
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={isCreatingStandard}
          disabled={isCreatingStandard}
        >
          Add
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ManageStandardsForm;
